import {
  getOffenseIcon,
  getSupportIcon,
  getDisruptIcon
} from '../battle/ArenaView/SubmissionMenu/icon-svg-getters/icon-folder'

export function getClassIcon(rpgClass = "", size="1em", style={}) {

  if (rpgClass === "dps") {
    return getOffenseIcon(size, {
      background: "#81455B",
      border: "0.2em solid #612F41",
      ...style
    })
  }
  if (rpgClass === "support") {
    return getSupportIcon(size, {
      background: "#E9AA5F", //fill gaps between pixels in Svg
      border: "0.2em solid #67632A",
      ...style
    })
  }
  if (rpgClass === "disrupt") {
    return getDisruptIcon(size, {
      background: "#6378FF",
      border: "0.2em solid #293893",
      ...style
    })
  }

  console.warn('rpgClass not recognized', rpgClass)
  return "";

}


// WEBPACK FOOTER //
// ./src/b5-home/get-class-icon.js